module.exports = __webpack_public_path__ + "img/shine.15507970.gif";